import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { s3ImageUrl } from '@/utils/config';
import { useInfluencerInfo } from '@/hooks/useInfluencerInfo';

export default function ReferralMenuBanner({
  setMenuOpen
}: {
  setMenuOpen: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { influencerInfo } = useInfluencerInfo();

  const { referralInfo } = influencerInfo || {};

  const handleReferral = () => {
    navigate('/referral');
    setMenuOpen(false);
  };

  if (!referralInfo?.inviteEnabled) return null;

  return (
    <div className="mx-4 mt-4 mb-8 relative md:hidden">
      <img
        src={`${s3ImageUrl}referral-menu-home.png`}
        alt="referral-home-bg"
        className="w-full"
      />
      <div className="absolute left-0 top-0 w-full px-3 py-4 flex flex-col gap-3 text-center">
        <img
          src={`${s3ImageUrl}invite-earn.png`}
          alt="invite-earn-icon"
          className="w-[225px] mx-auto"
        />
        <div className="w-80 text-center mx-auto">
          <span className="text-text-color-primary text-base font-normal font-['DM_Sans']">
            {t('navbar.referral.earn_up_to', {
              defaultValue: 'Refer creators and earn up to'
            })}{' '}
          </span>
          <span className="text-text-color-primary text-base font-bold font-['DM_Sans']">
            US$
          </span>
          <span className="text-text-color-primary text-base font-black font-['DM_Sans']">
            10,000
          </span>
          <span className="text-text-color-primary text-base font-normal font-['DM_Sans']">
            .{' '}
          </span>
        </div>
        <div className="flex flex-col gap-[6px]" onClick={handleReferral}>
          <div className="self-stretch h-8 px-4 py-2 bg-[#09090B] rounded-md inline-flex flex-col justify-center items-center gap-2.5">
            <div className="inline-flex justify-center items-center gap-2.5">
              <div className="justify-start text-white text-sm font-medium font-['Inter']">
                {t('navbar.referral.get_my_invite_link', {
                  defaultValue: 'Get my invite link'
                })}
              </div>
            </div>
          </div>
          <div className="justify-center w-[236px] mx-auto text-center">
            <span className="text-[#79716B] text-sm font-normal font-['DM_Sans']">
              {t('navbar.referral.rewards_apply', {
                defaultValue: 'Rewards apply to qualifying actions. View '
              })}
            </span>
            <span
              className="text-[#EC470A] text-sm font-normal font-['DM_Sans'] underline cursor-pointer"
              onClick={() =>
                window.open(
                  'https://chartreuse-wrinkle-697.notion.site/AhaCreator-Referral-Program-Terms-Conditions-30604daded68807db2dbcbeb382b43d6',
                  '_blank'
                )
              }
            >
              {t('navbar.referral.full_terms', { defaultValue: 'full terms' })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
